import loadable, { FallbackLoader } from 'components/utils/lazyImport'

export const OriginalFooter = loadable(() => import('./OriginalFooter'), <FallbackLoader inline />)

export const CompactFooter = loadable(() => import('./CompactFooter'), <FallbackLoader inline />)
